import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, Tooltip, getDate, setDateWithTimezone } from '@systemeio/ui';
import ContactPaymentsPaymentTooltip from 'modules/contacts/contact-page/components/contact-paymnet-tooltip';
import { ContactSubscriptionsStatusEnum } from 'modules/contacts/contact-page/enums/contact-subscriptions-enum';
import { useContactSubscriptions } from 'modules/contacts/contact-page/hooks/use-contact-subscriptions';
import { ContactPageFilterInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface';
import { ContactSubscriptionsInterface } from 'modules/contacts/contact-page/types/contact-subscriptions-interface';
import { getContactPaymentUrl } from 'modules/contacts/contact-page/utils/get-contact-payment-url';
import { ContactId, ContactInterface } from 'modules/contacts/types/contact-interface';
import UnsubscribeModal from 'modules/payment/subscriptions/components/unsubscribe-modal';
import React, { useEffect } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { OrderEnum } from 'shared/types/pagination-interface';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { getDateRangeSinceDate, getToday } from 'shared/utils/get-dates';
import { BlockedIcon, CheckIcon, PercentIcon } from '@systemeio/ui/icons';
interface ContactSubscriptionsProps {
  contactId: ContactId;
  contact?: ContactInterface;
}
const defaultFilters: ContactPageFilterInterface = {
  date: [null, null]
};
const ContactSubscriptions = t0 => {
  const $ = _c(104);
  const {
    contactId,
    contact
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters, true);
  const t1 = filter.date[0] !== null;
  let t2;
  if ($[0] !== contactId || $[1] !== filter || $[2] !== limit || $[3] !== pagination || $[4] !== t1) {
    t2 = {
      contactId,
      limit,
      pagination,
      filter,
      shouldFetch: t1
    };
    $[0] = contactId;
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    contactSubscriptions,
    mutate
  } = useContactSubscriptions(t2);
  let t3;
  if ($[6] !== mutate || $[7] !== user?.timezone) {
    t3 = async subscription => {
      await mutate(data => data && {
        items: data.items.map(item => {
          if (item.id === subscription.id) {
            item = {
              ...item,
              subscriptionItems: item.subscriptionItems.map(subscriptionItem => ({
                ...subscriptionItem,
                status: ContactSubscriptionsStatusEnum.cancelled,
                ...(subscriptionItem.status === ContactSubscriptionsStatusEnum.active ? {
                  deactivatedAt: setDateWithTimezone(undefined, user?.timezone).toISOString()
                } : {})
              }))
            };
          }
          return item;
        }),
        hasMore: data.hasMore
      }, false);
    };
    $[6] = mutate;
    $[7] = user?.timezone;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onUnsubscribe = t3;
  let t4;
  if ($[9] !== contact || $[10] !== setFilter || $[11] !== user?.timezone) {
    t4 = () => {
      if (contact) {
        setFilter({
          date: getDateRangeSinceDate(contact.createdAt, user?.timezone)
        });
      }
    };
    $[9] = contact;
    $[10] = setFilter;
    $[11] = user?.timezone;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = user?.timezone;
  let t6;
  if ($[13] !== contact || $[14] !== setFilter || $[15] !== t5) {
    t6 = [contact, setFilter, t5];
    $[13] = contact;
    $[14] = setFilter;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t4, t6);
  let t7;
  if ($[17] !== t) {
    t7 = t("dashboard.contact_page.plan");
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  let t9;
  if ($[19] !== t || $[20] !== user?.dateFormat || $[21] !== user?.timeFormat || $[22] !== user?.timezone) {
    t8 = subscription_0 => <div className="flex w-full flex-col truncate">{subscription_0.subscriptionItems.map((el, idx) => <div key={idx} className={`py-3 ${idx !== 0 && "border-text-secondary/30 border-t"} ${idx === 0 && "pt-0"} ${idx + 1 === subscription_0.subscriptionItems.length && "pb-0"}`}><div className="flex items-center justify-between gap-1.5"><div className="flex items-center gap-1.5 truncate"><ContactPaymentsPaymentTooltip orderItem={el.orderItem} />{subscription_0.customer.referredBy && <Tooltip label={subscription_0.customer.referredBy.email ?? ""} mode="hover"><PercentIcon className="fill-text-tertiary" /></Tooltip>}</div>{el.status === ContactSubscriptionsStatusEnum.active ? <Tooltip mode="hover" label={t("global.active")}><CheckIcon className="stroke-green" /></Tooltip> : <Tooltip mode="hover" label={`${t("global.cancelled")} ${el.deactivatedAt ? "(" + dateTimeFormat(el.deactivatedAt, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          }) + ")" : ""}`}><BlockedIcon className="fill-danger" /></Tooltip>}</div></div>)}</div>;
    t9 = subscription_1 => <div className="flex flex-col truncate">{subscription_1.subscriptionItems.map((el_0, idx_0) => <div key={idx_0} className={`truncate py-3 ${idx_0 !== 0 && "border-text-secondary/30 border-t"} ${idx_0 === 0 && "pt-0"} ${idx_0 + 1 === subscription_1.subscriptionItems.length && "pb-0"}`}><div className="flex items-center gap-1.5">{el_0.orderItem.offer && el_0.orderItem.offer.removedAt === null && el_0.orderItem.offer.funnelStep ? <LinkWithoutPrefetch rel="noreferrer" className="primary-link w-full truncate" href={getContactPaymentUrl(el_0.orderItem.offer.funnelStep.funnel.id, el_0.orderItem.offer.funnelStep.id)}>{el_0.orderItem.pricePlan ? el_0.orderItem.pricePlan.innerName : el_0.orderItem.productOrderItem && el_0.orderItem.productOrderItem.product.name}</LinkWithoutPrefetch> : <span>{el_0.orderItem.pricePlan.innerName}</span>}{subscription_1.customer.referredBy && <PercentIcon className="fill-text-tertiary" />}{el_0.status === ContactSubscriptionsStatusEnum.active ? <Tooltip mode="hover" label={t("global.active")}><CheckIcon className="stroke-green" /></Tooltip> : <Tooltip mode="hover" label={`${t("global.cancelled")} ${el_0.deactivatedAt ? "(" + dateTimeFormat(el_0.deactivatedAt, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          }) + ")" : ""}`}><BlockedIcon className="fill-danger" /></Tooltip>}</div></div>)}</div>;
    $[19] = t;
    $[20] = user?.dateFormat;
    $[21] = user?.timeFormat;
    $[22] = user?.timezone;
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = {
      key: "subscriptionItems",
      header: t7,
      onRender: t8,
      onRenderSmall: t9,
      widthPercent: 80
    };
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t) {
    t11 = t("global.created_on");
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== user?.dateFormat || $[32] !== user?.timeFormat || $[33] !== user?.timezone) {
    t12 = subscription_2 => <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(subscription_2.createdAt, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className="w-full truncate">{dateFormat(subscription_2.createdAt, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[31] = user?.dateFormat;
    $[32] = user?.timeFormat;
    $[33] = user?.timezone;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t11 || $[36] !== t12) {
    t13 = {
      key: "createdAt",
      widthPercent: 20,
      header: t11,
      onRender: t12
    };
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t10 || $[39] !== t13) {
    t14 = [t10, t13];
    $[38] = t10;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const columns = t14;
  let t15;
  if ($[41] !== t) {
    t15 = t("dashboard.contact_page.subscriptions");
    $[41] = t;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15) {
    t16 = <span className="text-[17px]">{t15}</span>;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  const t17 = user?.timezone;
  let t18;
  if ($[45] !== t17) {
    t18 = getToday(t17);
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const t19 = contact?.createdAt;
  const t20 = user?.timezone;
  let t21;
  if ($[47] !== t19 || $[48] !== t20) {
    t21 = getDate(t19, t20);
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== contact?.createdAt || $[51] !== user?.timezone) {
    t22 = () => getDateRangeSinceDate(contact?.createdAt, user?.timezone);
    $[50] = contact?.createdAt;
    $[51] = user?.timezone;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== setFilter || $[54] !== setLimit || $[55] !== setPagination) {
    t23 = date => {
      setPagination({
        startFromId: undefined,
        order: OrderEnum.next
      });
      setLimit(10);
      setFilter({
        date
      });
    };
    $[53] = setFilter;
    $[54] = setLimit;
    $[55] = setPagination;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  const t24 = user?.timezone;
  const t25 = user?.createdAt;
  let t26;
  if ($[57] !== filter.date || $[58] !== intlLocale || $[59] !== t18 || $[60] !== t21 || $[61] !== t22 || $[62] !== t23 || $[63] !== t24 || $[64] !== t25) {
    t26 = <DateRangePicker maxDate={t18} minDate={t21} getDefaultDate={t22} date={filter.date} onChange={t23} timezone={t24} createdAt={t25} intlLocale={intlLocale} />;
    $[57] = filter.date;
    $[58] = intlLocale;
    $[59] = t18;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
    $[63] = t24;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== limit || $[67] !== setLimit) {
    t27 = {
      limit,
      setLimit
    };
    $[66] = limit;
    $[67] = setLimit;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== pagination || $[70] !== setPagination) {
    t28 = {
      pagination,
      setPagination
    };
    $[69] = pagination;
    $[70] = setPagination;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== t) {
    t29 = t("dashboard.user.affiliate");
    $[72] = t;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== t29) {
    t30 = {
      name: "affiliate",
      caption: t29,
      shouldRender: _temp,
      setHref: _temp2,
      isNext: true,
      openInNew: false
    };
    $[74] = t29;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== t) {
    t31 = t("dashboard.contact_page.change_cc_info");
    $[76] = t;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== t31) {
    t32 = {
      name: "cc-info",
      caption: t31,
      shouldRender: _temp3,
      setHref: _temp4,
      openInNew: true
    };
    $[78] = t31;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== t30 || $[81] !== t32) {
    t33 = [t30, t32];
    $[80] = t30;
    $[81] = t32;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== t) {
    t34 = t("dashboard.subscriptions.unsubscribe");
    $[83] = t;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== onUnsubscribe) {
    t35 = (opened, onClose, subscription_7, key) => <UnsubscribeModal key={key} opened={opened} onClose={onClose} subscription={subscription_7} onUnsubscribe={onUnsubscribe} />;
    $[85] = onUnsubscribe;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t34 || $[88] !== t35) {
    t36 = [{
      name: "unsubscribe",
      caption: t34,
      onActionRender: t35,
      shouldRender: _temp6
    }];
    $[87] = t34;
    $[88] = t35;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  let t37;
  if ($[90] !== t33 || $[91] !== t36) {
    t37 = {
      openLink: t33,
      custom: t36
    };
    $[90] = t33;
    $[91] = t36;
    $[92] = t37;
  } else {
    t37 = $[92];
  }
  let t38;
  if ($[93] !== columns || $[94] !== contactSubscriptions || $[95] !== t27 || $[96] !== t28 || $[97] !== t37) {
    t38 = <Table limiter={t27} paginator={t28} actions={t37} data={contactSubscriptions} columns={columns} />;
    $[93] = columns;
    $[94] = contactSubscriptions;
    $[95] = t27;
    $[96] = t28;
    $[97] = t37;
    $[98] = t38;
  } else {
    t38 = $[98];
  }
  let t39;
  if ($[99] !== contactSubscriptions || $[100] !== t16 || $[101] !== t26 || $[102] !== t38) {
    t39 = <ListingLayout counter={false} data={contactSubscriptions} type="default" title={t16} customHeaderElement={t26}>{t38}</ListingLayout>;
    $[99] = contactSubscriptions;
    $[100] = t16;
    $[101] = t26;
    $[102] = t38;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  return t39;
};
export default ContactSubscriptions;
function _temp(subscription_3) {
  return subscription_3.customer.referredBy !== null;
}
function _temp2(subscription_4) {
  return `/affiliate-program/${subscription_4.customer.referredBy?.id}`;
}
function _temp3(subscription_5) {
  return subscription_5.changeCCLink !== null;
}
function _temp4(subscription_6) {
  return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}:${subscription_6.changeCCLink}`;
}
function _temp5(items) {
  return items.status === ContactSubscriptionsStatusEnum.active;
}
function _temp6(subscription_8) {
  return subscription_8.subscriptionItems.some(_temp5);
}